export default (uri = '') => {
    return window.siteUrl + uri
}